import React from 'react'

export interface SearchResultsTitleProps {}

export const SearchResultsTitle: React.FunctionComponent<SearchResultsTitleProps> =
	({ children }) => {
		return (
			<h2 className="searchResultsTitle">
				Výsledky hledání pro:{' '}
				<span className="searchResultsTitle-query">{children}</span>
			</h2>
		)
	}
